export default __webpack_public_path__ + "static/media/SWT1570.34I-37865_-22423_0.13913646.jpg";